import { useFormContext } from 'react-hook-form';
import { LwFormSelect } from 'redesign';

export type JobFormContext = {
  jobId: string;
};

type Props = {
  options: React.ComponentProps<typeof LwFormSelect>['options'];
  disabled?: React.ComponentProps<typeof LwFormSelect>['disabled'];
  required?: boolean;
};

export const JobFormElement = ({ options, disabled, required }: Props) => {
  const { control } = useFormContext<{ jobId: string }>();
  return (
    <LwFormSelect
      name="jobId"
      label="Functie"
      defaultLabel="Selecteer een functie..."
      options={options}
      disabled={disabled}
      control={control}
      data-testid="job-select"
      rules={required ? { required: 'Selecteer een functie' } : undefined}
    />
  );
};
